import { createContext } from 'react';
import type { StaticProductView } from 'state/product-description/types';

export const ProductViewContext = createContext<StaticProductView>('Default');
